module.exports = __webpack_public_path__ + "img/avatar7.95689bdc.png";